import HttpHelper from './helper';

export const playsStationTopTenPLayersEndpoints = {
    getTopTenPlayers: (params, signal) => HttpHelper.baseAxios
        .get('http://playstation.appcorp.mobi/api/top-ten', { params, signal })
        .then((res) => res)
        .catch((err) => err?.response?.data),
};
